import { render, staticRenderFns } from "./DialogFormaPagamento.vue?vue&type=template&id=5caafc1a&scoped=true&"
import script from "./DialogFormaPagamento.vue?vue&type=script&lang=js&"
export * from "./DialogFormaPagamento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5caafc1a",
  null
  
)

export default component.exports